import React from 'react';
import FacebookAd from './FacebookAd';

const GoogleAd = () => <FacebookAd channel="google" />;

export default GoogleAd;
